import _axios from "../axios.config";
import { END_POINTS } from "./endPoints";
import { userLogin } from "../redux/action";
import { toast } from "react-toastify";

//all redux

/**api for registering user */
export const registerUser = async (data, onError) => {
  try {
    let response = await _axios.post(END_POINTS.REGISTER, data);
    console.log("REGISTER-API-RESPONSE", response);
    localStorage.setItem("accessToken", response?.data?.data?.accessToken);
    localStorage.setItem("refreshToken", response?.data?.data?.refreshToken);
    return response?.data?.data;
  } catch (e) {
    if (onError) onError(e?.response?.data?.message);
  }
};
export const loginUser = async (data) => {
  try {
    const response = await _axios.post(END_POINTS.LOGIN, data);
   { if(response?.status!==200)
    toast.error(<div><p className="m-0 fw-bold">{response?.response?.data?.message}</p>
    <small className="d-block">Please provide correct email and password</small></div>);
   }

    localStorage.setItem("accessToken", response?.data?.data?.accessToken);
    localStorage.setItem("refreshToken", response?.data?.data?.refreshToken);

    return response?.data?.data;
  } catch (e) {
    const message =
      e?.response?.data?.message ||
      e?.response?.statusText ||
      "Something went wrong. Please try again.";

    toast.error(message);
    throw e;
  }
};


export const logoutUser = async (data, onError) => {
  try {
    let response = await _axios.post(END_POINTS.LOGOUT, data);
    localStorage.clear();
  } catch (e) {
    if (onError) onError(e?.response?.statusText);
  }
};

export const forgotPassword = async (data, onSuccess) => {
  try {
    let response = await _axios.post(END_POINTS.FORGOT_PASSWORD, data);
    console.log("forgot api response", response?.data?.message);
    if (onSuccess) {
      onSuccess(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
  }
};

export const verifyCode = async (data, onError, onSuccess) => {
  try {
    let response = await _axios.post(END_POINTS.VERIFY_RESET_PASSWORD, data);
    if (onSuccess) onSuccess(response?.data?.message);
  } catch (e) {
    if (onError) onError(e?.response?.data?.message);
  }
};

export const resendCode = async (data, onError, onSuccess) => {
  try {
    let response = await _axios.post(END_POINTS.RESEND_CODE, data);
    console.log("RESEND CODE ", response);
    if (onSuccess) onSuccess(response?.data?.message);
  } catch (e) {
    console.log("error====>", e);
    if (onError) onError(e?.response?.data?.message);
  }
};

export const resetPassword = async (data, onError, onSuccess) => {
  try {
    let response = await _axios.post(END_POINTS.RESET_PASSWORD, data);
    console.log("RESET PASSWORD===> ", response?.data?.message);
    if (onSuccess) onSuccess(response?.data?.message);
  } catch (e) {
    if (onError) onError(e?.response?.data?.errors[0]?.message);
  }
};

/**api for changing password **/

export const changePassword = async (data, onError, onSuccess) => {
  try {
    const response = await _axios.post(END_POINTS.CHANGE_PASSWORD, data);
    console.log("Change Password RESPONSE ===>", response);

    const message = response?.data?.message || "Password changed successfully";
    if (onSuccess) onSuccess(message);
    await new Promise((resolve) => {
      toast.success(message, {
        onClose: resolve,
      });
    });
    return { success: true };
  } catch (e) {
    const errorMessage =
      e?.response?.data?.errors?.[0]?.message ||
      e?.response?.data?.message ||
      "Something went wrong";

    if (onError) onError(errorMessage);
    toast.error(errorMessage);
    return { success: false };
  }
};
